import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets the window scroll to the top whenever the route (pathname) changes, so
 * navigating between pages always lands at the page beginning instead of the
 * previous scroll position.
 *
 * Skips the reset when the URL carries a hash, so in-page anchor links such as
 * `/#how-it-works` (the nav "Learn" link) still scroll to their target.
 *
 * Render once inside <BrowserRouter>, above <Routes>.
 */
const ScrollToTop = (): null => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
